/* Warsaw dispatch calendar and checkout-derived Polish delivery bands. */
(function (root) {
  const zone = 'Europe/Warsaw';
  const parts = date => Object.fromEntries(new Intl.DateTimeFormat('en-GB', {timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(date).filter(p=>p.type!=='literal').map(p=>[p.type,Number(p.value)]));
  const key = date => date.toISOString().slice(0,10);
  const plus = (date, days) => new Date(date.getTime()+days*86400000);
  function easter(year) {
    const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),n=h+l-7*m+114;
    return new Date(Date.UTC(year,Math.floor(n/31)-1,n%31+1));
  }
  const holidays = new Map();
  function businessDay(date) {
    const year=date.getUTCFullYear();
    if (!holidays.has(year)) {
      const fixed=['01-01','01-06','05-01','05-03','08-15','11-01','11-11','12-25','12-26'];
      if(year>=2025)fixed.push('12-24');
      holidays.set(year,new Set([...fixed.map(d=>`${year}-${d}`),key(plus(easter(year),1)),key(plus(easter(year),60))]));
    }
    return date.getUTCDay()!==0 && date.getUTCDay()!==6 && !holidays.get(year).has(key(date));
  }
  function nextBusiness(date) { let next=plus(date,1);while(!businessDay(next))next=plus(next,1);return next; }
  function warsawCutoff(date) {
    const civil=date.getTime()+14*3600000;
    let instant=civil;
    for(let i=0;i<2;i++) { const p=parts(new Date(instant));const wall=Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);instant+=civil-wall; }
    return instant;
  }
  function deliveryWindow(now = new Date()) {
    const p=parts(now),today=new Date(Date.UTC(p.year,p.month-1,p.day));
    const dispatch=businessDay(today)&&p.hour<14?today:nextBusiness(today);
    return {dispatch:key(dispatch),delivery:key(nextBusiness(dispatch)),seconds:Math.max(0,Math.ceil((warsawCutoff(dispatch)-now.getTime())/1000)),today:key(today)};
  }
  function shippingRate(grams,rates) {
    if(!Number.isSafeInteger(grams)||grams<=0)return null;
    const matches=rates.filter(r=>grams>=r.min&&(r.max===null||grams<=r.max));
    return matches.length===1?matches[0].cents:null;
  }
  function deliveryCopy(estimate) {
    const dayPhrases=['w niedzielę','w poniedziałek','we wtorek','w środę','w czwartek','w piątek','w sobotę'];
    const relative=value=>{
      const days=(Date.parse(value)-Date.parse(estimate.today))/86400000;
      return days===0?'dziś':days===1?'jutro':days===2?'pojutrze':dayPhrases[new Date(value+'T12:00:00Z').getUTCDay()];
    };
    const arrival=relative(estimate.delivery);
    const date=new Intl.DateTimeFormat('pl-PL',{day:'numeric',month:'long',timeZone:'UTC'}).format(new Date(estimate.delivery+'T12:00:00Z'));
    const minutes=Math.max(1,Math.ceil(estimate.seconds/60)),hours=Math.floor(minutes/60),rest=minutes%60;
    const duration=[hours?`${hours} godz.`:'',rest?`${rest} min.`:''].filter(Boolean).join(' ');
    return {title:`U Ciebie ${arrival} · ${date}`,countdown:`Zamów w ciągu ${duration}`,note:`Zamów ${relative(estimate.dispatch)} do 14:00`};
  }
  const api={deliveryWindow,shippingRate,deliveryCopy};
  if(typeof module!=='undefined'&&module.exports){module.exports=api;return;}
  root.MarbilyDelivery=api;
  let config,cart=null,cartVersion=0;
  const controllers=new Map();
  const write=(element,value)=>{if(element&&element.textContent!==value)element.textContent=value;};
  const money=cents=>new Intl.NumberFormat('pl-PL',{style:'currency',currency:'PLN'}).format(cents/100);
  const rootPath=window.Shopify?.routes?.root||'/';
  function currencyOK() {return (cart?.currency||window.Shopify?.currency?.active||'PLN')==='PLN';}
  function renderCartRate() {
    document.querySelectorAll('[data-mh-cart-shipping]').forEach(el=>{
      el.hidden=!cart?.item_count;
      if(!cart?.item_count)return;
      const price=currencyOK()?shippingRate(cart.total_weight,config?.rates||[]):null;
      el.querySelector('[data-mh-cart-shipping-price]').textContent=price===null?'Obliczymy w kasie':money(price);
    });
  }
  function acceptCart(value) {cart=value;cartVersion++;controllers.forEach(c=>c.update());renderCartRate();}
  document.addEventListener('mh:cart-updated',event=>acceptCart(event.detail.cart));
  async function readCart() {
    const version=++cartVersion;
    try {
      const response=await fetch(rootPath+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
      if(!response.ok)throw new Error('cart');
      const value=await response.json();if(version!==cartVersion)return;acceptCart(value);
    } catch(error) {if(version!==cartVersion)return;controllers.forEach(c=>c.update());}
  }
  function setup() {
    try {config=JSON.parse(document.getElementById('mh-shipping-rates')?.textContent||'null');}catch(error){config=null;}
    document.querySelectorAll('[data-mh-delivery]').forEach(el=>{
      if(controllers.has(el))return;
      const data=JSON.parse(el.querySelector('[data-mh-delivery-variants]').textContent);
      const scope=el.closest('.mh-look-product') || el.closest('.shopify-section');
      const title=el.querySelector('[data-mh-delivery-date]'),timer=el.querySelector('[data-mh-delivery-countdown]'),note=el.querySelector('[data-mh-delivery-note]'),cost=scope.querySelector('[data-mh-delivery-price]'),context=scope.querySelector('[data-mh-delivery-context]');
      const started = Date.now();
      function update() {
        if(!el.isConnected){controllers.get(el)?.observer?.disconnect();controllers.delete(el);return;}
        const dialog=el.closest('dialog');
        if(dialog && !dialog.open)return;
        const form=scope.querySelector('form[data-mh-add-cart], product-form form');
        const quantity=form?.querySelector('[name="quantity"]');
        const variant=data.find(v=>String(v.id)===String(form?.querySelector('[name="id"]')?.value));
        const qty=Number(quantity?.value||1);
        const validQty=Number.isSafeInteger(qty)&&qty>0;
        const inCart=cart?.items?.filter(item=>String(item.variant_id)===String(variant?.id)).reduce((sum,item)=>sum+item.quantity,0)||0;
        const available=variant?.available&&validQty&&(!variant.managed||variant.stock>=qty+inCart);
        if(available) {
          const copy=deliveryCopy(deliveryWindow());
          write(title,copy.title);
          write(timer,copy.countdown);
          const showCutoff = Math.floor((Date.now()-started)/30000)%2 === 1;
          timer.hidden=showCutoff;note.hidden=!showCutoff;
          write(note,copy.note);
        } else {
          write(title,'Termin dostawy do potwierdzenia');timer.hidden=true;note.hidden=false;
          write(note,validQty?'Zapytaj nas o dostępność wybranego wariantu i ilości.':'Wybierz prawidłową ilość produktu.');
        }
        const price=variant&&validQty&&currencyOK()&&variant.grams>0?shippingRate(variant.grams*qty,config?.rates||[]):null;
        write(cost,price!==null?money(price):'Obliczymy w kasie');
        write(context,validQty?`Dostawa za ${qty} szt.${price!==null?' wynosi ':': '}`:'Dostawa: ');
      }
      controllers.set(el,{update});
      scope.addEventListener('change',()=>setTimeout(update,0));scope.addEventListener('input',()=>setTimeout(update,0));
      // The native counter mutates input.value without always emitting input/change.
      scope.addEventListener('click',event=>{if(event.target.closest('.js-counter-increase,.js-counter-decrease'))setTimeout(update,0);});
      // Native theme updates the hidden id after fetching variant section HTML.
      const observer=new MutationObserver(records=>{if(records.some(record=>!el.contains(record.target)))update();});observer.observe(scope,{subtree:true,childList:true,attributes:true,attributeFilter:['value','disabled']});
      controllers.get(el).observer=observer;
      update();
    });
    renderCartRate();
  }
  function tick(){controllers.forEach((c,el)=>{if(el.isConnected)c.update();else{c.observer.disconnect();controllers.delete(el);}});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{setup();readCart();},{once:true});else{setup();readCart();}
  document.addEventListener('shopify:section:load',setup);
  document.addEventListener('mh:content-loaded',setup);
  document.addEventListener('mh:dialog-open',()=>{setup();tick();});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden){tick();readCart();}});
  setInterval(()=>{if(!document.hidden)tick();},1000);
})(typeof window!=='undefined'?window:globalThis);
